import React from 'react'

export const SkeletonLoader = () => (
  <div className="main_rgister_page">
    <div className="main-container relative min-h-screen">
      {/* Background Decorations */}
      <div className="fixed-background">
        <div className="bg-decorations">
          <div className="decoration-circle-1"></div>
          <div className="decoration-circle-2"></div>
          <div className="decoration-circle-3"></div>
          <div className="floating-shape-1"></div>
          <div className="floating-shape-2"></div>
          <div className="floating-shape-3"></div>
          <div className="triangle-1"></div>
          <div className="triangle-2"></div>
          <div className="diamond-1"></div>
          <div className="diamond-2"></div>
          <div className="wavy-line-1">
            <svg viewBox="0 0 30 240" className="w-full h-full">
              <path
                d="M15 0 Q25 30 15 60 Q5 90 15 120 Q25 150 15 180 Q5 210 15 240"
                stroke="rgba(255, 255, 255, 0.6)"
                strokeWidth="3"
                fill="none"
                opacity="0.8"
              />
            </svg>
          </div>
          <div className="wavy-line-2">
            <svg viewBox="0 0 20 160" className="w-full h-full">
              <path
                d="M10 0 Q15 20 10 40 Q5 60 10 80 Q15 100 10 120 Q5 140 10 160"
                stroke="rgba(245, 158, 11, 0.7)"
                strokeWidth="2"
                fill="none"
                opacity="0.7"
              />
            </svg>
          </div>
          <div className="particle-1"></div>
          <div className="particle-2"></div>
          <div className="particle-3"></div>
          <div className="particle-4"></div>
          <div className="particle-5"></div>
          <div className="gradient-orb-1"></div>
          <div className="gradient-orb-2"></div>
          <div className="gradient-orb-3"></div>
          <div className="polygon-1"></div>
          <div className="polygon-2"></div>
          <div className="spiral-1"></div>
          <div className="spiral-2"></div>
          <div className="star-1"></div>
          <div className="star-2"></div>
          <div className="star-3"></div>
          <div className="plus-1"></div>
          <div className="plus-2"></div>
        </div>
      </div>

      {/* Main Card */}
      <div className="card-container max-w-4xl mx-auto px-4">
        <div className="main-card bg-white rounded-lg shadow-lg">
          {/* Sticky Event Header */}
          <div className="sticky-event-header bg-white p-4 border-b">
            <div className="sticky-event-content">
              <div className="h-8 bg-blue-100 rounded animate-pulse w-3/4 mb-4"></div>
              <div className="sticky-event-details flex gap-4">
                <div className="sticky-event-item flex items-center gap-2">
                  <div className="h-4 w-4 bg-blue-100 rounded-full animate-pulse"></div>
                  <div className="h-4 bg-blue-100 rounded animate-pulse w-24"></div>
                </div>
                <div className="sticky-event-separator bg-blue-100 h-4 w-px animate-pulse"></div>
                <div className="sticky-event-item flex items-center gap-2">
                  <div className="h-4 w-4 bg-blue-100 rounded-full animate-pulse"></div>
                  <div className="h-4 bg-blue-100 rounded animate-pulse w-20"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Card Header with Enhanced Banner and Logo */}
          <div className="card-header relative mb-16">
            <div
              style={{
                position: 'relative',
                width: '100%',
                height: '200px',
                overflow: 'hidden',
                borderRadius: '12px 12px 0 0',
              }}
            >
              <div className="event-banner h-48 bg-blue-100 animate-pulse"></div>
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background:
                    'linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.6))',
                  zIndex: 1,
                  opacity: 0.5,
                  animation: 'pulse 2s infinite ease-in-out',
                }}
              ></div>
            </div>
            <div
              className="logo-container absolute top-[150px] left-1/2 transform -translate-x-1/2"
              style={{ zIndex: 10 }}
            >
              <div
                className="logo-wrapper bg-white p-2 rounded-lg shadow-lg animate-pulse"
                style={{
                  width: '100px',
                  height: '100px',
                  border: '3px solid #ffffff',
                  borderRadius: '16px',
                }}
              >
                <div className="logo-square bg-blue-100 w-full h-full rounded-lg"></div>
              </div>
            </div>
          </div>

          {/* Card Content */}
          <div className="card-content p-6">
            <div className="content-header flex items-center gap-4 mb-6">
              <div className="h-6 w-6 bg-blue-100 rounded-full animate-pulse"></div>
              <div className="h-6 bg-blue-100 rounded animate-pulse w-48"></div>
            </div>

            {/* Tickets Container */}
            <div className="tickets-container space-y-4">
              {[1, 2, 3].map((_, index) => (
                <div
                  key={index}
                  className="ticket-card bg-white p-4 rounded-lg shadow border border-gray-200"
                >
                  <div className="ticket-content flex justify-between items-center">
                    <div className="ticket-info space-y-2">
                      <div className="ticket-header flex gap-2 items-center">
                        <div className="h-5 bg-blue-100 rounded animate-pulse w-32"></div>
                        <div className="h-5 bg-blue-100 rounded animate-pulse w-16"></div>
                      </div>
                      <div className="h-4 bg-blue-100 rounded animate-pulse w-3/4"></div>
                      <div className="h-4 bg-blue-100 rounded animate-pulse w-1/2"></div>
                    </div>
                    <div className="ticket-actions space-y-2">
                      <div className="ticket-pricing">
                        <div className="h-5 bg-blue-100 rounded animate-pulse w-20"></div>
                        <div className="h-4 bg-blue-100 rounded animate-pulse w-16"></div>
                      </div>
                      <div className="h-10 bg-blue-100 rounded animate-pulse w-24"></div>
                    </div>
                  </div>
                  {/* Guest Section Placeholder */}
                  <div className="guest-section mt-4">
                    <div className="h-px bg-blue-100 animate-pulse"></div>
                    <div className="guest-header flex items-center gap-2 mt-2">
                      <div className="h-5 bg-blue-100 rounded animate-pulse w-40"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Sticky Bottom (Footer) */}
          <div className="sticky-bottom">
            <div className="total-section flex justify-between items-center">
              <div className="total-info space-y-2">
                <div className="h-6 bg-blue-100 rounded animate-pulse w-24"></div>
                <div className="h-4 bg-blue-100 rounded animate-pulse w-32"></div>
              </div>
              <div className="h-10 bg-blue-100 rounded animate-pulse w-40"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Inline CSS for Skeleton Loader */}
      <style>
        {`
          .main_rgister_page {
            background-color: #f4f6f9;
            min-height: 100vh;
          }
          .main-container {
            position: relative;
            max-width: 1200px;
            margin: 0 auto;
            padding: 16px;
          }
          .fixed-background {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: -1;
            overflow: hidden;
          }
          .bg-decorations {
            position: absolute;
            width: 100%;
            height: 100%;
          }
          .decoration-circle-1,
          .decoration-circle-2,
          .decoration-circle-3 {
            position: absolute;
            background: rgba(59, 130, 246, 0.1);
            border-radius: 50%;
            animation: pulse 4s infinite ease-in-out;
          }
          .decoration-circle-1 {
            width: 200px;
            height: 200px;
            top: 10%;
            left: 5%;
          }
          .decoration-circle-2 {
            width: 150px;
            height: 150px;
            top: 60%;
            right: 10%;
          }
          .decoration-circle-3 {
            width: 100px;
            height: 100px;
            bottom: 20%;
            left: 30%;
          }
          .floating-shape-1,
          .floating-shape-2,
          .floating-shape-3 {
            position: absolute;
            background: rgba(245, 158, 11, 0.2);
            border-radius: 20px;
            animation: float 6s infinite ease-in-out;
          }
          .floating-shape-1 {
            width: 80px;
            height: 80px;
            top: 20%;
            left: 15%;
          }
          .floating-shape-2 {
            width: 60px;
            height: 60px;
            top: 50%;
            right: 20%;
          }
          .floating-shape-3 {
            width: 100px;
            height: 100px;
            bottom: 10%;
            left: 40%;
          }
          .triangle-1,
          .triangle-2 {
            position: absolute;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 50px 86.6px 50px;
            border-color: transparent transparent rgba(59, 130, 246, 0.2) transparent;
            animation: float 5s infinite ease-in-out;
          }
          .triangle-1 {
            top: 30%;
            left: 10%;
          }
          .triangle-2 {
            bottom: 15%;
            right: 15%;
          }
          .diamond-1,
          .diamond-2 {
            position: absolute;
            width: 50px;
            height: 50px;
            background: rgba(245, 158, 11, 0.2);
            transform: rotate(45deg);
            animation: float 7s infinite ease-in-out;
          }
          .diamond-1 {
            top: 40%;
            left: 25%;
          }
          .diamond-2 {
            bottom: 25%;
            right: 30%;
          }
          .wavy-line-1,
          .wavy-line-2 {
            position: absolute;
            width: 30px;
            height: 240px;
          }
          .wavy-line-1 {
            top: 10%;
            left: 5%;
          }
          .wavy-line-2 {
            bottom: 10%;
            right: 5%;
          }
          .particle-1,
          .particle-2,
          .particle-3,
          .particle-4,
          .particle-5 {
            position: absolute;
            width: 10px;
            height: 10px;
            background: rgba(255, 255, 255, 0.5);
            border-radius: 50%;
            animation: float 3s infinite ease-in-out;
          }
          .particle-1 { top: 15%; left: 20%; }
          .particle-2 { top: 25%; right: 25%; }
          .particle-3 { bottom: 30%; left: 35%; }
          .particle-4 { bottom: 20%; right: 15%; }
          .particle-5 { top: 50%; left: 50%; }
          .gradient-orb-1,
          .gradient-orb-2,
          .gradient-orb-3 {
            position: absolute;
            width: 120px;
            height: 120px;
            background: radial-gradient(circle, rgba(59, 130, 246, 0.3), transparent);
            border-radius: 50%;
            animation: pulse 5s infinite ease-in-out;
          }
          .gradient-orb-1 { top: 5%; right: 10%; }
          .gradient-orb-2 { bottom: 5%; left: 20%; }
          .gradient-orb-3 { top: 50%; right: 30%; }
          .polygon-1,
          .polygon-2 {
            position: absolute;
            width: 60px;
            height: 60px;
            background: rgba(245, 158, 11, 0.2);
            clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
            animation: float 6s infinite ease-in-out;
          }
          .polygon-1 { top: 20%; left: 30%; }
          .polygon-2 { bottom: 30%; right: 20%; }
          .spiral-1,
          .spiral-2 {
            position: absolute;
            width: 80px;
            height: 80px;
            background: rgba(59, 130, 246, 0.2);
            border-radius: 50%;
            animation: spin 8s infinite linear;
          }
          .spiral-1 { top: 15%; left: 40%; }
          .spiral-2 { bottom: 15%; right: 10%; }
          .star-1,
          .star-2,
          .star-3 {
            position: absolute;
            width: 20px;
            height: 20px;
            background: rgba(245, 158, 11, 0.3);
            clip-path: polygon(
              50% 0%,
              61% 35%,
              98% 35%,
              68% 57%,
              79% 91%,
              50% 70%,
              21% 91%,
              32% 57%,
              2% 35%,
              39% 35%
            );
            animation: float 4s infinite ease-in-out;
          }
          .star-1 { top: 10%; left: 50%; }
          .star-2 { top: 60%; right: 15%; }
          .star-3 { bottom: 10%; left: 25%; }
          .plus-1,
          .plus-2 {
            position: absolute;
            width: 30px;
            height: 30px;
            background: rgba(59, 130, 246, 0.2);
            clip-path: polygon(
              40% 0%,
              60% 0%,
              60% 40%,
              100% 40%,
              100% 60%,
              60% 60%,
              60% 100%,
              40% 100%,
              40% 60%,
              0% 60%,
              0% 40%,
              40% 40%
            );
            animation: float 5s infinite ease-in-out;
          }
          .plus-1 { top: 25%; left: 10%; }
          .plus-2 { bottom: 20%; right: 25%; }
          @keyframes pulse {
            0%, 100% { transform: scale(1); opacity: 0.3; }
            50% { transform: scale(1.2); opacity: 0.5; }
          }
          @keyframes float {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-20px); }
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .card-container {
            padding-top: 16px;
          }
          .main-card {
            position: relative;
            border-radius: 12px;
            overflow: hidden;
          }
          .sticky-event-header {
            position: sticky;
            top: 0;
            z-index: 10;
            background-color: #fff;
          }
          .sticky-event-content {
            max-width: 100%;
            margin: 0 auto;
          }
          .card-content {
            padding-bottom: 120px; /* Space for sticky-bottom */
          }
          .ticket-card {
            border: 1px solid #e5e7eb;
          }
          .sticky-bottom {
            position: fixed;
            bottom: 20px;
            right: 20px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 8px;
            padding: 16px;
            background-color: #fff;
            border-radius: 8px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            z-index: 1000;
          }
          .total-section {
            display: flex;
            align-items: center;
            gap: 16px;
          }
          .total-info {
            flex-grow: 1;
          }
        `}
      </style>
    </div>
  </div>
)
